import '../components/faq/faq.css'

import { SharedLayout } from '@amzn/woot-services-vendor-portal-shared-ui/components'
import { useRef } from 'react'

import { FaqContent, FaqSidebar } from '../components'
import { faqData } from '../constants'

/**
 * FAQ page component
 * Displays a comprehensive FAQ page with navigation sidebar and content sections
 * Uses standard HTML anchor links for navigation
 */
const PageFaq = () => {
  const contentRef = useRef<HTMLDivElement>(null)

  return (
    <SharedLayout title="FAQ">
      <div className="faq-card">
        <h1 className="faq-page-title">Frequently Asked Questions</h1>
        <div className="faq-container">
          <FaqSidebar faqData={faqData} />
          <FaqContent ref={contentRef} faqData={faqData} />
        </div>
      </div>
    </SharedLayout>
  )
}

export default PageFaq
